export default "__VITE_ASSET__COzlwviK__"